import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppFlyoutAnchor, createAppToggleButton } from 'owa-command-ribbon';
import Checkmark from 'owa-fluent-icons-svg/lib/icons/CheckmarkFilled';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { getMenuDefinitionForControls } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type { IButtonStyles } from '@fluentui/react';
import { FormatControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';
import {
    bandedRows,
    firstColumn,
    bandedColumns,
    headerRow,
    tableStyleOptions,
} from './tableControlsStrings.locstring.json';
import { RibbonViewState } from 'owa-editor-ribbonplugin-store';
import { AppControlProps } from '@1js/acui-ribbon-like';
import applyTableFormat from './applyTableFormat';

export const getTableFormatStateMenu = computedFn(
    (
        editorId: string,
        ribbonViewState: RibbonViewState,
        styles: IButtonStyles | undefined,
        icon: string | undefined
    ): RibbonControlProps => {
        return createAppFlyoutAnchor(
            getComposeRibbonId(FormatControlId.TableStyleOptions, editorId),
            loc(tableStyleOptions),
            getMenuDefinitionForControls([
                createAppToggleButton(
                    getComposeRibbonId(FormatControlId.HeaderRowTableStyle, editorId),
                    loc(headerRow),
                    () => applyTableFormat('hasHeaderRow', editorId),
                    ribbonViewState.tableFormatState?.hasHeaderRow as boolean,
                    undefined /* keyTips */,
                    Checkmark,
                    undefined /* iconColor */,
                    styles /* styles*/,
                    { toggleUsingIcon: true }
                ) as AppControlProps,
                createAppToggleButton(
                    getComposeRibbonId(FormatControlId.FirstColumnTableStyle, editorId),
                    loc(firstColumn),
                    () => applyTableFormat('hasFirstColumn', editorId),
                    ribbonViewState.tableFormatState?.hasFirstColumn as boolean,
                    undefined /* keyTips */,
                    Checkmark,
                    undefined /* iconColor */,
                    styles /* styles*/,
                    { toggleUsingIcon: true }
                ) as AppControlProps,
                createAppToggleButton(
                    getComposeRibbonId(FormatControlId.BandedColumnsTableStyle, editorId),
                    loc(bandedColumns),
                    () => applyTableFormat('hasBandedColumns', editorId),
                    ribbonViewState.tableFormatState?.hasBandedColumns as boolean,
                    undefined /* keyTips */,
                    Checkmark,
                    undefined /* iconColor */,
                    styles /* styles*/,
                    { toggleUsingIcon: true }
                ) as AppControlProps,
                createAppToggleButton(
                    getComposeRibbonId(FormatControlId.BandedRowsTableStyle, editorId),
                    loc(bandedRows),
                    () => applyTableFormat('hasBandedRows', editorId),
                    ribbonViewState.tableFormatState?.hasBandedRows as boolean,
                    undefined /* keyTips */,
                    Checkmark,
                    undefined /* iconColor */,
                    styles /* styles*/,
                    { toggleUsingIcon: true }
                ) as AppControlProps,
            ]),
            undefined /* keytipProps */,
            icon,
            undefined /* iconColor */,
            styles
        );
    }
);
